import Vue from 'vue';
import VueI18n from 'vue-i18n';
import router from '../router';

import axios from './request';

import zh from '../locales/zh-cmn-Hans.json';

Vue.use(VueI18n);

export const defaultLocale = process.env.VUE_APP_I18N_LOCALE || 'zh-cmn-Hans';
export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'zh-cmn-Hans',
  messages: {
    'zh-cmn-Hans': zh,
  },
});

const loadedLanguages = ['zh-cmn-Hans']; // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export function loadLanguageAsync(lang) {
  if (!lang) lang = defaultLocale;
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }
  // If the language hasn't been loaded yet
  return Promise.resolve(require(`@/locales/${lang}.json`)).then((messages) => {
    i18n.setLocaleMessage(lang, messages);
    loadedLanguages.push(lang);
    return setI18nLanguage(lang);
  });
  /*
  return import(`@/locales/en.json`).then((messages) => {
    i18n.setLocaleMessage(lang, messages.default);
    loadedLanguages.push(lang);
    return setI18nLanguage(lang);
  });*/
}

export async function setLocaleToPath(lang) {
  await loadLanguageAsync(lang);
  if (lang === defaultLocale) {
    lang = '';
  }
  let pathNew = lang + router.currentRoute.path;
  router.replace({
    name: router.currentRoute.name,
    params: {
      ...router.currentRoute.params,
      lang: lang,
    },
    /*
    path: pathNew,
    query: {
      ...router.currentRoute.query,
    },*/
  });
}
